import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import * as actions from "../../../../store/actions";
import {
  REMOVE_VALIDATIONS,
  VALIDATE_PATIENT_PERSONAL_INFO,
} from "../../../../store/actions/actionTypes";
import { getUserData } from "../../../../utils/localStorage";
import { getOnboardingPath } from "../../../../constants";
import constants from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import Row from "../../../../components/uiElements/grid/Row";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";

import { PersonalDetailsCard } from "./PersonalDetailsCard";
import { AllergyDetailsCard } from "./AllergyDetailsCard";
import { MedicalConditionCard } from "./MedicalConditionCard";
import { MedicationDetailsCard } from "./MedicationDetailsCard";
import { SurgeryDetailsCard } from "./SurgeryDetailsCard";
import { FamilyaMedicalConditionCard } from "./FamilyMedicalConditionCard";

const StepOne = ({
  personalPatientInfo,
  setPatientPersonalInfo,
  history,
  form,
  validateData,
  savePatientDetails,
  removeValidations,
  addAllergy,
  removeAllergy,
  addFamilyMedicalHistory,
  removeFamilyMedicalHistory,
  addMedicalCondition,
  removeMedicalCondition,
  addMedication,
  setMedication,
  removeMedication,
  addPreviousSurgery,
  removePreviousSurgery,
  addCurrentMedicationTimes,
  addMedicationTimes,
  setPreviousSurgery,
  redirectedPath,
  updatePatientDetails,
}) => {
  const myRef = useRef();

  useEffect(() => {
    if (form && form.personalPatientInfo) {
      if (personalPatientInfo.dataLoaded && personalPatientInfo.dataChanged) {
        updatePatientDetails(() => {
          history.push(getOnboardingPath("/contact"));
          console.log("contact");
        });
      } else {
        savePatientDetails(() => {
          history.push(getOnboardingPath("/contact"));
        });
        console.log("contact");
      }
    }

    form.personalPatientInfo = false;
    toast.error(form.gender, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.date_of_birth, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.medicine_timing, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.medicine_consumption_period, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.surgery_date, {
      position: constants.TOAST_POSITION,
    });

    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    const userData = getUserData();

    if (!personalPatientInfo.firstName && !personalPatientInfo.lastName) {
      setPatientPersonalInfo({
        firstName: userData.firstName,
      });
      setPatientPersonalInfo({
        lastName: userData.lastName,
      });
    }
    removeValidations();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {redirectedPath && (
        <Prompt
          when={personalPatientInfo.dataChanged}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      )}
      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // personalPatientInfo.dataLoaded && "disable"
        )}
      >
        <p className="onboarding-header">
          Personal
          <br /> Details
        </p>
        <Row>
          <PersonalDetailsCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            form={form}
          />
          <AllergyDetailsCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            addAllergy={addAllergy}
            removeAllergy={removeAllergy}
            form={form}
          />
          <MedicalConditionCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            addMedicalCondition={addMedicalCondition}
            removeMedicalCondition={removeMedicalCondition}
            form={form}
          />
          <MedicationDetailsCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            addCurrentMedicationTimes={addCurrentMedicationTimes}
            addMedication={addMedication}
            addMedicationTimes={addMedicationTimes}
            removeMedication={removeMedication}
            setMedication={setMedication}
            form={form}
          />
          <SurgeryDetailsCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            addPreviousSurgery={addPreviousSurgery}
            removePreviousSurgery={removePreviousSurgery}
            setPreviousSurgery={setPreviousSurgery}
            form={form}
          />
          <FamilyaMedicalConditionCard
            personalPatientInfo={personalPatientInfo}
            setPatientPersonalInfo={setPatientPersonalInfo}
            addFamilyMedicalHistory={addFamilyMedicalHistory}
            removeFamilyMedicalHistory={removeFamilyMedicalHistory}
            form={form}
          />
          <Button
            type="secondary"
            indicatorButton
            className={classnames(
              "float-right next-button",
              personalPatientInfo.dataLoaded && "enable"
            )}
            onClick={() =>
              !personalPatientInfo.currentAllergy &&
              !personalPatientInfo.current_dosage &&
              !personalPatientInfo.current_family_medical_history &&
              !personalPatientInfo.current_instructions &&
              !personalPatientInfo.current_medical_condition &&
              personalPatientInfo.current_medicine_consumption_period.length ===
                0 &&
              !personalPatientInfo.current_medicine_name &&
              !personalPatientInfo.current_medicine_timing &&
              !personalPatientInfo.current_surgery_date &&
              !personalPatientInfo.current_surgery_name &&
              personalPatientInfo.dataChanged
                ? validateData(personalPatientInfo)
                : history.push(getOnboardingPath("/contact"))
            }
            label={<OnboardingIcon type="nextButton" />}
          />
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  personalPatientInfo: onboarding.patientPersonalInfo,
  form: validation.data,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  setPatientPersonalInfo: updatedData =>
    dispatch(actions.setPatientPersonalInfo(updatedData)),
  validateData: personalPatientInfo =>
    dispatch(
      actions.validateData(VALIDATE_PATIENT_PERSONAL_INFO, personalPatientInfo)
    ),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
  savePatientDetails: cb => dispatch(actions.savePatientDetails(cb)),
  updatePatientDetails: cb => dispatch(actions.updatePatientDetails(cb)),

  // Allergy
  addAllergy: () => dispatch(actions.addAllergy()),
  removeAllergy: index => dispatch(actions.removeAllergy(index)),

  // Family Medical history
  addFamilyMedicalHistory: () => dispatch(actions.addFamilyMedicalHistory()),
  removeFamilyMedicalHistory: index =>
    dispatch(actions.removeFamilyMedicalHistory(index)),
  // Medical condition
  addMedicalCondition: () => dispatch(actions.addMedicalCondition()),
  removeMedicalCondition: index =>
    dispatch(actions.removeMedicalCondition(index)),
  // Medication Details
  addMedication: () => dispatch(actions.addMedication()),
  setMedication: (type, data, index) =>
    dispatch(actions.setMedication(type, data, index)),
  removeMedication: index => dispatch(actions.removeMedication(index)),
  // Surgery Details
  addPreviousSurgery: () => dispatch(actions.addPreviousSurgery()),
  setPreviousSurgery: (type, index, data) =>
    dispatch(actions.setPreviousSurgery(type, index, data)),
  removePreviousSurgery: index =>
    dispatch(actions.removePreviousSurgery(index)),
  // Medication Time
  addCurrentMedicationTimes: data =>
    dispatch(actions.addCurrentMedicationTimes(data)),
  addMedicationTimes: (type, data, index) =>
    dispatch(actions.addMedicationTimes(type, data, index)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepOne)
);
